import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

const EMPTY = { name: "", category: "Associazione di categoria", description: "", logo_url: "/partners/logo-test.svg", website: "", active: true, featured: false, order: 0 };
const FIELDS = [["name", "Nome"], ["category", "Categoria"], ["description", "Descrizione"], ["logo_url", "URL logo"], ["website", "Sito web (https://…)"]];

function PartnerForm({ initial, onSave, onCancel }) {
  const [f, setF] = useState(initial);
  return (
    <div className="grid gap-2 rounded-2xl border border-slate-200 bg-white p-4 sm:grid-cols-2" data-testid="partner-form">
      {FIELDS.map(([k, l]) => <Input key={k} data-testid={`partner-input-${k}`} placeholder={l} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />)}
      <Input type="number" data-testid="partner-input-order" placeholder="Ordine" value={f.order} onChange={(e) => setF({ ...f, order: Number(e.target.value) })} />
      <label className="flex items-center gap-2 text-sm"><Switch data-testid="partner-input-active" checked={f.active} onCheckedChange={(v) => setF({ ...f, active: v })} /> Visibile</label>
      <label className="flex items-center gap-2 text-sm"><Switch data-testid="partner-input-featured" checked={!!f.featured} onCheckedChange={(v) => setF({ ...f, featured: v })} /> Partner del mese (uno solo)</label>
      <div className="flex gap-2 sm:col-span-2">
        <Button data-testid="partner-save-btn" onClick={() => onSave(f)} className="rounded-full bg-emerald-600 hover:bg-emerald-700">Salva</Button>
        <Button variant="outline" data-testid="partner-cancel-btn" onClick={onCancel} className="rounded-full">Annulla</Button>
      </div>
    </div>
  );
}

export function PartnersAdmin() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/partners").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
  }, []);
  const save = async (f) => {
    const { id, created_at, updated_at, sample, ...body } = f;
    try {
      await (id ? api.put(`/admin/partners/${id}`, body) : api.post("/admin/partners", body));
      toast.success("Partner salvato");
      setEdit(null);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const remove = async (p) => {
    if (!window.confirm(`Eliminare ${p.name}?`)) return;
    await api.delete(`/admin/partners/${p.id}`).then(() => { toast.success("Partner eliminato"); load(); }).catch((e) => toast.error(errMsg(e)));
  };
  return (
    <div className="space-y-3" data-testid="admin-partners">
      {!edit && <Button data-testid="partner-new-btn" onClick={() => setEdit(EMPTY)} className="rounded-full bg-emerald-600 hover:bg-emerald-700">Nuovo partner</Button>}
      {edit && <PartnerForm initial={edit} onSave={save} onCancel={() => setEdit(null)} />}
      {items.map((p) => (
        <div key={p.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 text-sm" data-testid={`admin-partner-${p.id}`}>
          <img src={p.logo_url} alt="" className="h-10 w-10 rounded-lg object-contain" />
          <span className="flex-1"><b>{p.name}</b> · {p.category}{!p.active && <span className="ml-2 text-xs text-amber-700">nascosto</span>}{p.featured && <span className="ml-2 rounded-full bg-fuchsia-100 px-2 text-xs font-bold text-fuchsia-700" data-testid={`admin-partner-featured-${p.id}`}>Partner del mese</span>}</span>
          <Button size="sm" variant="outline" data-testid={`partner-edit-${p.id}`} onClick={() => setEdit(p)}>Modifica</Button>
          <Button size="sm" variant="outline" data-testid={`partner-delete-${p.id}`} onClick={() => remove(p)} className="text-rose-600">Elimina</Button>
        </div>
      ))}
    </div>
  );
}
